import type { RefObject } from 'react';
import { useEffect } from 'react';

function useOutsideClick<T extends HTMLElement>(
  ref: RefObject<T>,
  onOutsideClick: () => void
): void {
  useEffect(() => {
    function handleClickOutside(event: MouseEvent): void {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        onOutsideClick();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, onOutsideClick]);
}

export default useOutsideClick;